import React, { useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "../../pages/authPages/authPages.css";
import CustomInput from "../../components/customInput/CustomInput";
import { ReactComponent as EyeCross } from "../../assets/eyeCross.svg";
import { ReactComponent as Eye } from "../../assets/fi-rr-eye.svg";
import CustomButton from "../../components/CustomButton";
import { Link, useNavigate } from "react-router-dom";
import base_url from "../../api/bootapi";
import axios from "axios";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../../components/Reducers/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const LoginComponent = ({ authFlow }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [backdropopen, setbackdropopen] = useState(false);

  const isFormValid = email && password;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setbackdropopen(true);
    try {
      const response = await axios.post(`${base_url.api1}/users/login`, {
        email,
        password,
      });

      dispatch(loginSuccess(response.data));
        //   navigate("/");
        authFlow('none')
      console.log("login page", response.data);
      toast.success("User Logged In Successfully");
      setbackdropopen(false);
    } catch (err) {
      setError(err.response?.data?.message);
      toast.error(err.response?.data?.message);
      // console.error("Error:", err);
      setbackdropopen(false);
    }
  };
  // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9
  return (
    <div className="modal-login-container">
   
      <div className="login">
        <div className="login-container " >
          <div>
            <h3 className="login-header">Log in to your account</h3>
            <p className="sub-login-header">
              Access your dashboard and manage your account
            </p>
          </div>

          {/* <ToastContainer /> */}
          <form className="input-container" onSubmit={(e) => handleSubmit(e)}>
            <div style={{ marginTop: "30px" }}>
              <label className="login-label">
                Email address <span style={{ color: "#D04244" }}>*</span>
              </label>
              <div
                style={{ border: error ? "1px solid #D04244" : "none" }}
                className="input-box"
              >
                <input
                  className="save-progress-input"
                  placeholder={"Enter your email"}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div style={{ marginTop: "20px" }}>
              <label className="login-label">
                Password <span style={{ color: "#D04244" }}>*</span>
              </label>
              <div
                style={{ border: error ? "1px solid #D04244" : "none" }}
                className="input-box"
              >
                <input
                  className="save-progress-input"
                  placeholder={"Enter your password"}
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <EyeCross /> : <Eye />}
                </button>
              </div>
            </div>

            <div style={{ marginTop: "5px" }}>
              {error ? (
                <p style={{ textAlign: "center", color: "#D04244" }}>{error}</p>
              ) : (
                <p></p>
              )}
            </div>

            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <Link
                style={{ textDecoration: "none" }}
                to="/login/forgot-password"
              >
                <p style={{ color: "#314064", fontWeight: "700" }}>
                  Forgot your password?
                </p>
              </Link>
            </div>

                      

                        {
                                                backdropopen ?
                                                
                                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"40px"}}>
                                                        <CircularProgress color="inherit"size={'30px'} /> 
                                                    </div>
                                                    : <CustomButton
                                    style={{
                width: "100%",
                marginTop: "20px",
                backgroundColor: !isFormValid ? "#ccc" : "#314064",
                cursor: !isFormValid ? "not-allowed" : "pointer",
              }}
              btnText="LOGIN"
              type="submit"
              disabled={!isFormValid}
                                  />
                      
                                            }
                                 


           

            <p
              onClick={() => authFlow('register')}
              style={{
                textAlign: "center",
                marginTop: "20px",
                cursor: "pointer",
              }}
            >
              Don't have an account yet?{" "}
              <span style={{ color: "#314064", fontWeight: "700" }}>
                Sign up now!
              </span>
            </p>
          </form>
        </div>
      </div>
  
    </div>
  );
};

export default LoginComponent;
